const getMeasureSearchTerm = (state) => state.measureSearchTerm;

const getAnalyticsMeasuresList = (state) => state.analyticsMeasuresList;

export default {
  getMeasureSearchTerm,
  getAnalyticsMeasuresList,
};
